import { z } from 'zod'

import { SoquijSecretZod } from './soquij-secret-zod'

export const SecretsZod = z.discriminatedUnion('_id', [SoquijSecretZod.extend({ _id: z.literal('soquij') })])
